var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:_vm.loading?'lock':'',attrs:{"outline":"","large":"","color":_vm.color,"loading":_vm.loading},on:{"click":function($event){_vm.loader = 'loading'}}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }